<div>
  <h3 class="meta-subheader flat">
    Resource Permissions
    <button type="button" mat-button (click)="add()">
      <mat-icon class="material-symbols-outlined">add</mat-icon>Add
    </button>
  </h3>
  <div class="mat-table-container">
    <table mat-table [dataSource]="matData" class="rde-table">
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let row" class="mat-column semi-bold">{{ row.email }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let row">{{ row.role }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="mat-column">
          <span>
            <a
              mat-button
              (click)="remove(row)"
              [disabledInteractive]="isImmortal(row)"
              [matTooltip]="immortalityReason(row)"
              ><mat-icon class="material-symbols-outlined">delete</mat-icon>Delete</a
            ></span
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
</div>
